"use client";
import { cn } from "@workspace/ui/lib/utils";

interface AnimatedWaveProps {
  backgroundColor?: "background" | "teal" | "purple";
  strokeColor?: "background" | "teal" | "purple";
  className?: string;
  position?: "top" | "bottom";
}

export function AnimatedWave({
  backgroundColor = "background",
  strokeColor = "teal",
  className,
  position = "bottom",
}: AnimatedWaveProps = {}) {
  // Static wave path (no animation)
  const baseAmplitude = 20;
  const wavePath = `M0,60 Q360,${60 - baseAmplitude} 720,60 T1440,60`;

  // Map color options to Tailwind CSS variables/colors
  const getColorValue = (color: "background" | "teal" | "purple"): string => {
    switch (color) {
      case "background":
        return "var(--background)"; // Uses oklch format
      case "teal":
        return `var(--teal-500)`;
      case "purple":
        return `var(--violet-950)`;
      default:
        return "var(--background)";
    }
  };

  const fillColor = getColorValue(backgroundColor);
  const borderColor = getColorValue(strokeColor);

  return (
    <svg
      className={cn(
        "absolute",
        position === "top" ? "top-0 -translate-y-20" : "bottom-0",
        "left-0 w-full h-20",
        className
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 120"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path d={`${wavePath} L1440,120 L0,120 Z`} fill={fillColor} />
      {/* Border on top edge only */}
      <path d={wavePath} stroke={borderColor} strokeWidth="8" fill="none" />
    </svg>
  );
}
